






















































import { Component, Vue } from "vue-property-decorator";
import { BOverlay } from "bootstrap-vue";

import EntityCrud from "../entity/EntityCrud.vue";
import EntityForm from "@/views/entity/EntityForm.vue";
import needModel from "@/api/need.model";
import { translateNeedKind } from "@/interfaces/need";
import Table from "@/layouts/components/Table.vue";
import MenuButton from "@/layouts/components/MenuButton.vue";
import CorporateClientAndPlans from "@/layouts/components/CorporateClientAndPlans.vue";
import BaseModal from "@/layouts/components/BaseModal.vue";
import SolutionModel from "@/api/solution.model";

@Component({
	components: {
		EntityCrud,
		EntityForm,
		BOverlay,
		"custom-table": Table,
		MenuButton,
		BaseModal,
		CorporateClientAndPlans,
	},
})
export default class Needs extends Vue {
	model: any = needModel;
	title = "Necessidades";
	kind = "tableAndForm";
	formStyleVariant = "secondary";
	titleKind = "secondary";
	shouldShowExportButton = true;
	eventType = "need:find";
	shouldShowButtonMinimizeTable = true;
	shouldShowPagination = true;
	showModalAssignClientCorporate = false;
	solutionModel = SolutionModel;

	solutionId = "";
	solutionRelationData: any = null;
	solutionIsLoading = false;
	solutionsOpen = true;
	solutionHeaders = [
		{
			key: "name",
			style: "bold",
			kind: "text",
			name: "Nome",
		},
		{
			key: "corporateClient",
			style: "bold",
			kind: "text",
			name: "Cliente corporativo",
			translated: (values: any) => {
				const corporateClients: Set<string> = new Set();

				values.forEach((value: any) => {
					const corporateClient = value?.insurerPlan?.corporateClient?.name;

					if (corporateClient) corporateClients.add(corporateClient);
				});

				return [...corporateClients].join(", ");
			},
		},
		{
			key: "status",
			style: "bold",
			kind: "text",
			name: "Status",
			translated: (value: string) => {
				const options: Record<string, string> = {
					VALIDATE: "Validar",
					CONFIRMED: "Confirmado",
					REFUSED: "Recusado",
					INACTIVATED: "Inativada",
				};

				return options[value] || "Não identificado";
			},
		},
		{
			key: "description",
			style: "bold",
			kind: "text",
			name: "Descrição",
		},
	];
	solutionData: any = null;

	modalClosed() {
		this.showModalAssignClientCorporate = false;
		this.updateSolutionRelationData(null);
	}

	shouldGoToPreviousPageAfterRemove = false;
	onRemoveEntity() {
		this.$root.$emit("refreshTable");
	}

	onClickSolutionLine(data: any) {
		this.updateSolutionRelationData(data.id);
		this.showModalAssignClientCorporate = true;
		this.$route.params.id = data.id;
	}

	updateSolutionRelationData(solutionId: string | null) {
		const currentSolution = this.solutionData?.find((solution: any) => solution.id === solutionId);
		if (!currentSolution) this.solutionRelationData = null;
		this.solutionRelationData = {
			["category.id"]: currentSolution.category.id,
			solutionInsurerPlans: currentSolution.corporateClient.map((corporateClient: any) => corporateClient),
			name: currentSolution.name,
		};
	}

	toggleSolutions() {
		this.solutionsOpen = !this.solutionsOpen;
	}

	async refreshSolutionData() {
		if (!this.solutionId) return;

		this.solutionIsLoading = true;
		try {
			const updatedSolutions = await needModel.getSolutions(this.solutionId);
			this.solutionData = updatedSolutions;
		} catch (error) {
			// Error silently handled
		} finally {
			this.solutionIsLoading = false;
			this.modalClosed();
		}
	}

	async onChangeEntityId(entityId: string) {
		this.solutionIsLoading = true;

		const solutions = await needModel.getSolutions(entityId);

		this.solutionData = solutions;

		this.solutionId = entityId;
		this.solutionIsLoading = false;
	}

	exportColumns = [
		{ key: "id", name: "Id" },
		{ key: "name", name: "Nome" },
		{ key: "kind", name: "Categoria", style: "bold" },
		{ key: "tussCode", name: "TUSS" },
		{ key: "synonyms", name: "Sinônimos" },
		{ key: "solution", name: "Solução" },
	];

	tableColumns = [
		{ key: "name", style: "bold", excludedFromSearch: false },
		{ key: "kind", style: "bold", excludedFromSearch: false },
	];

	formColumns = [
		{ key: "name", isReadOnly: false, required: true },
		{ key: "kind", inputKind: "selectButtons", onTransform: translateNeedKind, required: true },
		{ key: "tussCode" },
		{ key: "synonyms" },
	];
}
